
import { CancelToken } from "axios";
import { QueryResult } from "../../Common/domain/src/api/queryResult";
import { axiosClient } from "../../Common/api/axiosClient";
import { ICommandResult } from "../../Common/domain/src/api/commandResult";
import { IAssociateCommand } from "../commands/association";

export class customerClient extends axiosClient {

  async getCustomersForRequestedConnection(token: string, connection: string, cancelToken?: CancelToken | undefined): Promise<QueryResult> {
    let action = "/api/v1/useraccounts/get-customer-by-connection";
    action = action.replace(/[?&]$/, "");

    return await this.get(action + "?ConnectionName=" + connection, this.Authorize(token), cancelToken);
  }

  async getCustomersShortNameAndCode(token: string, cancelToken?: CancelToken | undefined): Promise<QueryResult> {
    let action = "/api/v1/useraccounts/get-customers-short-name-and-code";
    action = action.replace(/[?&]$/, "");

    return await this.get(action, this.Authorize(token), cancelToken);
  }

  async associateWithCustomer(token: string, body: IAssociateCommand, cancelToken?: CancelToken | undefined): Promise<ICommandResult> {
    let action = "/api/v1/useraccounts/associate";
    action = action.replace(/[?&]$/, "");

    return await this.post<IAssociateCommand>(action, body, this.Authorize(token));
  }
}
